// AUTO-GENERATED from `aspen_medium.json` — do not edit by hand. Regenerate via the preset
//   → `.ts` conversion script when the upstream preset JSONs change.
import type {DeepPartial, TreeOptions} from "../options.js";

const options: DeepPartial<TreeOptions> = {
    "seed": 18020,
    "type": "deciduous",
    "bark": {
      "type": "Bark002",
      "tint": 16777215,
      "flatShading": false,
      "textured": true,
      "textureScale": {
        "x": 1,
        "y": 1
      }
    },
    "branch": {
      "levels": 2,
      "angle": {
        "1": 75,
        "2": 32,
        "3": 7
      },
      "children": {
        "0": 10,
        "1": 3,
        "2": 3
      },
      "force": {
        "direction": {
          "x": 0,
          "y": 1,
          "z": 0
        },
        "strength": 0.0148
      },
      "gnarliness": {
        "0": 0.05,
        "1": 0.12,
        "2": 0.12,
        "3": 0.02
      },
      "length": {
        "0": 50,
        "1": 6.07,
        "2": 11.19,
        "3": 1
      },
      "radius": {
        "0": 0.72,
        "1": 0.41,
        "2": 0.7,
        "3": 0.7
      },
      "sections": {
        "0": 12,
        "1": 10,
        "2": 8,
        "3": 6
      },
      "segments": {
        "0": 8,
        "1": 6,
        "2": 4,
        "3": 3
      },
      "start": {
        "1": 0.59,
        "2": 0.35,
        "3": 0
      },
      "taper": {
        "0": 0.37,
        "1": 0.13,
        "2": 0.7,
        "3": 0.7
      },
      "twist": {
        "0": 0,
        "1": 0,
        "2": 0,
        "3": 0
      }
    },
    "leaves": {
      "type": "aspen",
      "billboard": "double",
      "angle": 30,
      "count": 11,
      "start": 0.124,
      "size": 2.5,
      "sizeVariance": 0.7,
      "tint": 16775778,
      "alphaTest": 0.5
    },
    "trellis": {
      "enabled": false
    }
  };

export default options;
